import React from 'react';
import { AppBar, Box, Button, Container, Menu, MenuItem, Toolbar, List, ListItemButton, ListItemText, ListItemIcon, Collapse, Popover, ClickAwayListener } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { useUser } from '../../userContext';
import { useNavigate } from 'react-router-dom';
import NotificationBar from './notificationBar';

const navigation = [
  { text: 'Alerts', href: '/alerts' },
  { text: 'Inventory', href: '/inventory' },
  { text: 'NeTERS', href: '/neters' },
];
const netersSubMenu = [
  { text: 'Sensor 001', href: '/neters' },
  { text: 'Flow', href: '/flow/home' }
];

const help = [
  { text: 'Shippers', href: '/shippers' },
  { text: 'Operator Guide', href: '/operatorGuide' },
  { text: 'What\'s New', href: '/whatsNew' },
  { text: 'Features', href: '/features' },
  { text: 'User Profile', href: '/userProfile'},
  { text: 'PhenTalk', href: '/phenTalk'}, 
];

const admin = [
  { text: 'Show Groups', href: '/groups' },
  { text: 'Show Users', href: '/users' },
  { text: 'Settings', href: '/settings' },
  { text: 'Options', href: '/options' },
  { text: 'SLA Alerts', href: '/slaAlerts' },
  { text: 'Shippers', href: '/shippers' },
  { text: 'User Metrics', href: '/metrics' },
  { text: 'Change Password', href: '/changePassword' },
  { text: 'Update Demo Data' }  
];

const adminData = [
  { text: 'Alerts', href: '/adminAlerts' },
  { text: 'Applications', href: '/adminApplications' },
  { text: 'Attack Types', href: '/adminAttackTypes' },
  { text: 'What\'s New', href: '/adminWhatsNew' },
  { text: 'New Features', href: '/adminFeatures' },
  { text: 'Notifications', href: '/adminNotifications' },  
  { text: 'Simulations', href: '/adminSimulations' },  
  { text: 'Tooltips', href: '/adminTooltips' }
];

const analytics = [
  { text: 'Bandwidth Usage', href: '/bandwidthUsage' },
  { text: 'CVE Info', href: '/cveInfo' },
  { text: 'CVE Details', href: '/cveDetails' },
  { text: 'Severities Found - Pie Chart', href: '/severitiesFound' },
  { text: 'Severities Found - Table', href: '/severitiesFoundTable' },
  { text: 'Source IPs', href: '/sourceIps' },
  { text: 'Users And Systems', href: '/usersAndSystems' },
  { text: 'Weekly Failed Logins', href: '/weeklyFailedLogins' },
  { text: 'Threat Hunting', href: '/threatHunting' },
  { text: 'Threat Hunting Details', href: '/beaconThreathunt' },
  { text: 'PTVS Overview', href: '/ptvsOverview' },
  { text: 'PTVS Details', href: '/ptvsDetails' },
  { text: 'Compliance Dashboards'},
  { text: 'eMASS Dashboards'},
  { text: 'Phen.AI Activity', href: '/phenActivity'}
];
const compliance = [
  { text: 'CIS Overview', href: '/cisOverview' },
  { text: 'CIS Details', href: '/cisDetails' },
  { text: 'PCI Overview', href: '/pciOverview' },
  { text: 'PCI Details', href: '/pciDetails' },
  { text: 'NIST Overview', href: '/nistOverview' },
  { text: 'NIST Details', href: '/nistDetails' },
  { text: 'MITRE Attack', href: '/mitreAttack' },
  { text: 'MITRE Attack Details', href: '/mitreAttackDetails' },
  { text: 'SOC Overview', href: '/socOverview' },
  { text: 'SOC Details', href: '/socDetails' },
  { text: 'HIPAA Overview', href: '/hipaaOverview' },
  { text: 'HIPAA Details', href: '/hipaaDetails' },
];
const eMass = [
  { text: 'PM Overview', href: '/pmOverview' },
  { text: 'ISSO/ISSM Overview', href: '/issoOverview' },
  { text: 'Enterprise Overview', href: '/enterpriseOverview' },
  { text: 'AO Scorecard', href: '/aoScorecard' },
  { text: 'Implementation Roadmap', href: '/roadmap' },
  { text: 'AO Oversight', href: '/aoOversight' },
  { text: 'System Details', href: '/systemOverview' },
  { text: 'Trending', href: '/trending' },
];

const simulate = [
  { text: 'Simulator', href: '/simulator' }
];

export default function NavBar() {  
  const navigate = useNavigate();
  const { authenticated, userRole } = useUser();
  const [anchorElNavigation, setAnchorElNavigation] = React.useState(null);
  const [anchorElHelp, setAnchorElHelp] = React.useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = React.useState(null);
  const [anchorElAnalytics, setAnchorElAnalytics] = React.useState(null);
  const [anchorElSimulate, setAnchorElSimulate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openCompliance, setOpenCompliance] = React.useState(false);
  const [openEMass, setOpenEMass] = React.useState(false);

  const openNavigation = Boolean(anchorElNavigation);
  const handleOpenNavigationMenu = (event) => {
    setAnchorElNavigation(event.currentTarget);
  };
  const handleCloseNavigationMenu = (page) => {
    setAnchorElNavigation(null);
    if (page) {
      navigate(page);
    }
  };

  const openHelp = Boolean(anchorElHelp);
  const handleOpenHelpMenu = (event) => {
    setAnchorElHelp(event.currentTarget);
  };
  const handleCloseHelpMenu = (page) => {
    setAnchorElHelp(null);
    if (page) {
      navigate(page);
    }
  };

  const openAdmin = Boolean(anchorElAdmin);
  const handleOpenAdminMenu = (event) => {
    setAnchorElAdmin(event.currentTarget);
  };
  const handleCloseAdminMenu = (page) => {
    setAnchorElAdmin(null);
    if (page) {
      navigate(page);
    }
  };

  const openAnalytics = Boolean(anchorElAnalytics);
  const handleOpenAnalyticsMenu = (event) => {
    setAnchorElAnalytics(event.currentTarget);
  };
  const handleCloseAnalyticsMenu = (page) => {
    setAnchorElAnalytics(null);
    setOpen(false);
    if (page) {
      navigate(page);
    }
  };

  const handleToggleCompliance = () => {
    setOpenCompliance(!openCompliance);
  };
  const handleToggleEMass = () => {
    setOpenEMass(!openEMass);
  };
  const handleClick = () => {
    setOpen(!open);
  }

  const openSimulate = Boolean(anchorElSimulate);
  const handleOpenSimulateMenu = (event) => {
    setAnchorElSimulate(event.currentTarget);
  };
  const handleCloseSimulateMenu = (page) => {
    setAnchorElSimulate(null);
    if (page) {
      navigate(page);
    }
  };

  const [anchorElPopover, setAnchorElPopover] = React.useState(null);
  const isPopoverOpen = Boolean(anchorElPopover);
  const handlePopoverOpen = (event) => {
    setAnchorElPopover(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };

  return (
    <>
      { authenticated &&
        <>
          <NotificationBar />
          <AppBar position="static" sx={{ width: '100vw', height: '50px', bgcolor: '#2A2D2F', margin: 0, padding: 0 }}>
            <Container maxWidth={false} sx={{ width: '80%', maxWidth: 'none' }}>
              <Toolbar disableGutters sx={{ justifyContent: 'space-between', width: '100%' }}>
                {/* Navigation Menu */}
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>              
                  <Button
                    id="navigation-button"
                    aria-controls={openNavigation ? 'navigation-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openNavigation ? 'true' : undefined}
                    onClick={handleOpenNavigationMenu}
                    sx={{ color: '#FFF' , 
                    '&:hover': {
                      backgroundColor: '#545353'}}}
                  >
                    Navigation
                  </Button>
                  <Menu
                    id="navigation-menu"
                    anchorEl={anchorElNavigation}
                    open={openNavigation}
                    onClose={() => handleCloseNavigationMenu()}
                    slotProps={{
                      list: {
                        'aria-labelledby': 'navigation-button',
                      },
                    }}
                  >
                    {navigation.map((item) => item.text == 'NeTERS'
                    ? (
                      <List disablePadding component="div" sx={{ overflowY: 'visible' }}>
                        <ListItemButton 
                          onClick={handlePopoverOpen} 
                          sx={{ height: '2.1em' }}
                          aria-owns={isPopoverOpen ? 'mouse-over-popover' : undefined}
                          aria-haspopup="true"
                          onMouseEnter={handlePopoverOpen}
                        >
                          <ListItemText primary="NeTERS" />
                          <ExpandMore />
                        </ListItemButton>
                          <Popover
                            id='mouse-over-popover'
                            sx={{ pointerEvents: 'auto'}}
                            open={isPopoverOpen}
                            anchorEl={anchorElPopover}
                            anchorOrigin={{
                              vertical: 'center',
                              horizontal: 'right',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                            disableRestoreFocus
                          >
                            <div onMouseLeave={() => { handlePopoverClose() }}>
                              <List disablePadding >
                                {netersSubMenu.map((subItem) => (
                                  <ListItemButton 
                                    primary={subItem.text}
                                    sx={{ height: '2.1em'}} 
                                    onClick={() => {
                                      handleCloseNavigationMenu(subItem.href);
                                      handlePopoverClose();
                                    }}
                                  >
                                    <ListItemText primary={subItem.text} />
                                  </ListItemButton>
                                ))}
                              </List>
                            </div>
                          </Popover>
                      </List>
                    ) 
                  : (
                    <MenuItem key={item.text} onClick={() => handleCloseNavigationMenu(item.href)}>
                      {item.text}
                    </MenuItem>                      
                  ) )}
                  </Menu>
                </Box>

                {/* Analytics Menu */}
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>              
                  <Button
                    id="analytics-button"
                    aria-controls={openAnalytics ? 'analytics-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openAnalytics ? 'true' : undefined}
                    onClick={handleOpenAnalyticsMenu}
                    sx={{ color: '#FFF' , 
                    '&:hover': {
                      backgroundColor: '#545353'}}}
                  >
                    Analytics
                  </Button>
                  <Menu
                    disableScrollLock
                    id="analytics-menu"
                    anchorEl={anchorElAnalytics}
                    open={openAnalytics}
                    onClose={() => handleCloseAnalyticsMenu()}
                    slotProps={{
                      paper: {
                        style: {
                          maxHeight: '85vh',
                          overflowY: 'auto'
                        },
                      },
                      list: {
                        'aria-labelledby': 'analytics-button',
                      },
                     }}
                    // sub menus for Compliance Dashboards
                  >
                    {analytics.map((item) => item.text == 'Compliance Dashboards'
                    ? (
                      <List disablePadding component="div" sx={{overflowY:'visible'}}>
                        <ListItemButton 
                          onClick={handleToggleCompliance} 
                          anchorEl={anchorElAnalytics}
                          open={openAnalytics}
                          sx={{height: '2.1em'}}
                          >
                            <ListItemText primary='Compliance Dashboards'/>
                              {openCompliance ? <ExpandLess/> : <ExpandMore/>}
                        </ListItemButton>
                        <Collapse in={openCompliance} timeout="auto" unmountOnExit>
                          <List disablePadding>
                            {compliance.map((subItem) => (
                              <ListItemButton sx={{height: '2.1em'}} onClick={() => handleCloseAnalyticsMenu(subItem.href)}>
                                <ListItemIcon/>
                                <ListItemText primary={subItem.text} />
                              </ListItemButton>
                            ))}
                          </List>
                        </Collapse>
                      </List>
                      )
                    // sub menus for eMass Dashboards
                    : item.text == 'eMASS Dashboards' ? (
                      <List disablePadding component="div" sx={{overflowY:'visible'}}>
                        <ListItemButton 
                          onClick={handleToggleEMass} 
                          anchorEl={anchorElAnalytics}
                          open={openAnalytics}
                          sx={{height: '2.1em'}}
                          >
                            <ListItemText primary='eMASS Dashboards'/>
                              {openEMass ? <ExpandLess/> : <ExpandMore/>}
                        </ListItemButton>
                        <Collapse in={openEMass} timeout="auto" unmountOnExit>
                          <List disablePadding>
                            {eMass.map((subItem) => (
                              <ListItemButton sx={{height: '2.1em'}} onClick={() => handleCloseAnalyticsMenu(subItem.href)}>
                                <ListItemIcon/>
                                <ListItemText primary={subItem.text} />
                              </ListItemButton>
                            ))}
                          </List>
                        </Collapse>
                      </List>
                     )
                    : (
                      <MenuItem key={item.text} onClick={() => handleCloseAnalyticsMenu(item.href)}>
                        {item.text}
                      </MenuItem>                      
                    ))}
                  </Menu>
                </Box>

                {/* Admin Menu */}   
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>              
                  <Button
                    id="admin-button"
                    aria-controls={openAdmin ? 'admin-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openAdmin ? 'true' : undefined}
                    onClick={handleOpenAdminMenu}
                    sx={{ color: '#FFF' ,
                    '&:hover': {
                      backgroundColor: '#545353'}}}
                  >
                    Admin
                  </Button>
                  <Menu
                    id="admin-menu"
                    anchorEl={anchorElAdmin}
                    open={openAdmin}
                    onClose={() => handleCloseAdminMenu()}
                    slotProps={{
                      list: {
                        'aria-labelledby': 'admin-button',
                      },
                    }}
                  >
                    
                    {admin.map((item) => 
                      userRole === 'admin' && item.text !== 'Update Demo Data' ?
                          <MenuItem key={item.text} onClick={() => handleCloseAdminMenu(item.href)}>
                              {item.text}
                          </MenuItem>
                      : userRole === 'admin' && item.text == 'Update Demo Data' ?
                          <List disablePadding>
                              <ListItemButton 
                                  onClick={handleClick} 
                                  anchorEl={anchorElAdmin}
                                  open={openAdmin}
                                  sx={{height: '2.1em'}}
                              >
                              <ListItemText primary='Update Demo Data'/>
                                  {open ? <ExpandLess/> : <ExpandMore/>}
                              </ListItemButton>
                              <Collapse in={open} timeout="auto">
                                <List disablePadding>
                                  {adminData.map((item) => (
                                    <ListItemButton sx={{height: '2.1em'}} onClick={() => handleCloseAdminMenu(item.href)}>
                                      <ListItemIcon/>
                                      <ListItemText primary={item.text} />
                                    </ListItemButton>
                                  ))}
                                </List>
                              </Collapse>
                          </List>
                      : item.text === 'Options' || item.text === 'Settings' || item.text === 'Change Password' ? 
                          <MenuItem key={item.text} onClick={() => handleCloseAdminMenu(item.href)}>
                              {item.text}
                          </MenuItem>
                      : 
                          <MenuItem key={item.text} onClick={() => handleCloseAdminMenu(item.href)} disabled>
                              {item.text}
                          </MenuItem>      
                    )}
                  </Menu>
                </Box>

                {/* Help Menu */}        
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>              
                  <Button
                    id="help-button"
                    aria-controls={openHelp ? 'help-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openHelp ? 'true' : undefined}
                    onClick={handleOpenHelpMenu}
                    sx={{ color: '#FFF' , 
                    '&:hover': {
                      backgroundColor: '#545353'}}}
                  >
                    Help
                  </Button>
                  <Menu
                    id="help-menu"
                    anchorEl={anchorElHelp}
                    open={openHelp}
                    onClose={() => handleCloseHelpMenu()}
                    slotProps={{
                      list: {
                        'aria-labelledby': 'help-button',
                      },
                    }}
                  >
                    {help.map((item) => (
                      <MenuItem key={item.text} onClick={() => handleCloseHelpMenu(item.href)}>
                        {item.text}
                      </MenuItem>                      
                    ))}
                  </Menu>
                </Box>            

                {/* Simulate Menu */}        
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>              
                  <Button
                    id="help-button"
                    aria-controls={openSimulate ? 'simulate-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openSimulate ? 'true' : undefined}
                    onClick={handleOpenSimulateMenu}
                    sx={{ color: '#FFF', 
                    '&:hover': {
                      backgroundColor: '#545353'}}}
                  >
                    Simulate
                  </Button>
                  <Menu
                    id="simulate-menu"
                    anchorEl={anchorElSimulate}
                    open={openSimulate}
                    onClose={() => handleCloseSimulateMenu()}
                    slotProps={{
                      list: {
                        'aria-labelledby': 'simulate-button',
                      },
                    }}
                  >
                    {simulate.map((item) => (
                      <MenuItem key={item.text} onClick={() => handleCloseSimulateMenu(item.href)}>
                        {item.text}
                      </MenuItem>                      
                    ))}
                  </Menu>
                </Box>
              </Toolbar>
            </Container>
            {/* <NotificationBar /> */}
          </AppBar>        
        </>
      }
    </>
  );
}
